import { render, staticRenderFns } from "./CooperationSystemList.vue?vue&type=template&id=52db7088&scoped=true&lang=pug"
import script from "./CooperationSystemList.vue?vue&type=script&lang=ts"
export * from "./CooperationSystemList.vue?vue&type=script&lang=ts"
import style0 from "./CooperationSystemList.vue?vue&type=style&index=0&id=52db7088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52db7088",
  null
  
)

export default component.exports